module.exports = __webpack_public_path__ + "img/calendar-icon.f369d19f.svg";